import ThemedStateIcon, { ThemedStateIconProps } from './ThemedStateIcon';

export type { ThemedStateIconProps };
export default ThemedStateIcon;
